const pendingByWorkoutId = new Map()

export const setPendingWorkoutText = (workoutId, text) => {
  if (!workoutId) return

  const defined = Object.fromEntries(Object.entries(text).filter(([, value]) => value !== undefined))
  pendingByWorkoutId.set(workoutId, { ...pendingByWorkoutId.get(workoutId), ...defined })
}

export const clearPendingWorkoutText = (workoutId) => {
  pendingByWorkoutId.delete(workoutId)
}

export const takePendingWorkoutText = (workoutId) => {
  const pending = pendingByWorkoutId.get(workoutId) || {}
  pendingByWorkoutId.delete(workoutId)
  return pending
}
